import React from 'react';
import { Container as MuiContainer, Box } from '@material-ui/core';
import styled from 'styled-components';
import { LoginForm } from '../../modules';

const Container = styled(MuiContainer)`
    align-items: center;
    &&{
        display: flex;
    }
`;
const Login = () => (
    <Container maxWidth="sm">
        <Box flexGrow={1}>
            <LoginForm />
        </Box>
    </Container>
);

export default Login;
